"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Bag4x6Window;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Bag7x6WindowModule = _interopRequireDefault(require("./Bag7x6Window.module.scss"));

var _BagWindow = _interopRequireDefault(require("../BagWindow/BagWindow"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Bag4x6Window(_ref) {
  var itemPool = _ref.itemPool,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;
  return /*#__PURE__*/_react.default.createElement(_BagWindow.default, {
    sizeX: 7,
    sizeY: 6,
    itemPool: itemPool,
    className: (0, _classnames.default)(_Bag7x6WindowModule.default.window, className),
    classNameDragHandler: _Bag7x6WindowModule.default.dragHandler,
    classNameCloseBtn: _Bag7x6WindowModule.default.closeBtn,
    classNameItemPool: _Bag7x6WindowModule.default.itemPool,
    style: style
  });
}